import { render, staticRenderFns } from "./mobileFootView.vue?vue&type=template&id=7ab7a922&scoped=true"
import script from "./mobileFootView.vue?vue&type=script&lang=js"
export * from "./mobileFootView.vue?vue&type=script&lang=js"
import style0 from "./mobileFootView.vue?vue&type=style&index=0&id=7ab7a922&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ab7a922",
  null
  
)

export default component.exports